module.exports = __webpack_public_path__ + "static/game_ats-60d814eeea61085241ecd75bbe5c1283.png";